module.exports = __webpack_public_path__ + "static/media/users.285d2766.svg";